import { createContext, useContext } from 'react'

export type FeedbackScope = 'drawer' | 'global'
export type FeedbackTone = 'error' | 'info' | 'success' | 'warning'

export interface ShowFeedbackOptions {
  detail?: string
  durationMs?: number | null
  message: string
  scope?: FeedbackScope
  title?: string
  tone: FeedbackTone
}

export interface FeedbackContextValue {
  dismissFeedback: (scope: FeedbackScope) => void
  showFeedback: (options: ShowFeedbackOptions) => void
}

export const FeedbackContext = createContext<FeedbackContextValue | null>(null)

export function useFeedback() {
  const context = useContext(FeedbackContext)
  if (!context) {
    throw new Error('useFeedback must be used within FeedbackProvider.')
  }

  return context
}
